import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=c85c8da4&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=c85c8da4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85c8da4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c85c8da4')) {
      api.createRecord('c85c8da4', component.options)
    } else {
      api.reload('c85c8da4', component.options)
    }
    module.hot.accept("./Announcement.vue?vue&type=template&id=c85c8da4&scoped=true", function () {
      api.rerender('c85c8da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/Announcement.vue"
export default component.exports